import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';

import { TxtAttach } from '../../core/index.model';
import { Guid } from '../../core/guid';
import { ParameterConfigService, SessionStorageService, PageContentService, CommonService } from '../../core/index.service';
import { AppState } from '../../statemanagement/app.state';
import { Store } from '@ngrx/store';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pnx-file',
    templateUrl: './file.control.html',
    styleUrls: ['./file.control.css']
})
export class FileControl implements OnInit, OnDestroy {

    /**
    * acceptFileExtensions: .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|images/*
    *
    */
    @Input() fileInputID: string = "file";
    @Input() acceptFileExtensions: string = '';
    @Input() addMultipleFiles: boolean = false;
    @Input() allowableFileSize: number = 5;

    @Input() JurisID: number;
    @Input() RefID: string;
    @Input() SourceID: number;
    @Input() SourceType: string;
    @Input() readonly: boolean = false;
    
    @Input() addButtonCss: string = "csp-btn blue wA";
    @Input() downloadButtonCss: string;
    @Input() deleteButtonCss: string;

    @Input() attachments: TxtAttach[] = [];
    @Output() onFileAdd: EventEmitter<TxtAttach[]> = new EventEmitter<TxtAttach[]>();

    @Input() clearControl: boolean = false;

    fileToUpload: File = null;
    fileListToUpload: File[] = [];

    uploadProgress: number = 0;
    uploadComplete: boolean = false;
    uploadingProgressing: boolean = false;
    fileUploadSub: any;
    serverResponse: any;
    message: string = "";
    processCount: number;
    showWarning: boolean = false;

    sourcelocation: string;
    ngrxStoreSubscription: Subscription;
    paramValue: string;
    pdfUrl: SafeResourceUrl;
    isShowBiReport: boolean = false;
    isAcceptFile: boolean = false;
    showLoading: boolean = false;
    isError: boolean;
    isAlert: boolean;
    isWarning: boolean;

    constructor(public snackBar: MatSnackBar,
        private paramConfigService: ParameterConfigService,
        private storageService: SessionStorageService,
        private store: Store<AppState>,
        private pageContentService: PageContentService,
        private commonService: CommonService,
        public sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.showWarning = false;

        this.sourcelocation = this.storageService.getJurisName() != null ? this.storageService.getJurisName().match(/(Police Department|Police|Department|Police Dept|Sheriff|Office)/) ? '' : 'Police Department' : 'Police Department';
        this.ngrxStoreSubscription = this.store.select("parameter").subscribe(paramObject => {
            if (paramObject) {
                if (this.acceptFileExtensions == '') {
                    this.allowableFileSize = 1;
                    this.acceptFileExtensions = this.paramConfigService.GetSystemParamValue(84);
                }
                var res = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(this.acceptFileExtensions.replace("?rs:Embed=true", ""));
                if (this.acceptFileExtensions) { }
                else if (res) {
                    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.acceptFileExtensions);
                }
                else {
                    this.showAlert("Please check the System Parameter (84) in Admin Section.", true, true);
                    this.showLoading = false;
                }
            }
        });
    }

    ngOnChanges(Changes: SimpleChanges) {
        
        if (this.clearControl) {

            for (let i = this.attachments.length; i >= 0; --i) {
                this.cmdRemoveFile(i);
            }
        }
    }
    ngOnDestroy() {
        if (this.fileUploadSub) {
            this.fileUploadSub.unsubscribe()
            this.ngrxStoreSubscription.unsubscribe();
        }
    }
   

    //cmdProgress(event) {
    //    if (event.type === HttpEventType.DownloadProgress) {
    //        this.uploadingProgressing = true;
    //        this.uploadProgress = Math.round(100 * event.loaded / event.total);
    //        console.log(this.uploadProgress);
    //    }

    //    if (event.type === HttpEventType.UploadProgress) {
    //        this.uploadingProgressing = true;
    //        this.uploadProgress = Math.round(100 * event.loaded / event.total);
    //        console.log(this.uploadProgress);
    //    }

    //    if (event.type === HttpEventType.Response) {
    //        this.uploadComplete = true;
    //        this.serverResponse = event.body;
    //    }
    //}

    //cmdSubmit(event: any) {
    //    event.preventDefault();
    //    if (this.fileListToUpload) {
    //        this.fileUploadSub = this.fileUploadService.multiplefileUpload(
    //            this.fileListToUpload).subscribe(
    //            event => this.cmdProgress(event),
    //            error => {
    //                console.log("Server error")
    //            });
    //    }
    //}

    cmdAddFiles() {
        document.getElementById(this.fileInputID).click();
    }
    
    cmdFileInput(files: File[]) {
        
        this.showWarning = false;

        let fileItem = files[0];

        this.fileToUpload = fileItem;
        this.processCount = 0;
        
        if (this.addMultipleFiles == false) {
            this.attachments = [];
        }

        for (let fi = 0; fi < files.length; fi++) {
            this.cmdFileReader(files[fi], files.length, fi);
        }
    }

    cmdFileReader(ifile: File, fileCount: number, index: number) {
        var myReader: FileReader = new FileReader();

        myReader.onloadend = (e) => {

            var match = (new RegExp('[~#%\&{}+\|*@!`$=:/;?,<>]|\\.\\.|^\\.|\\.$')).test(ifile.name);
            let base64File = myReader.result.split(',')[1];

            let fileName = ifile.name.split('.');
                let ext = ifile.name.substr((ifile.name.lastIndexOf('.') + 1));

                var _filesize
                let totalBytes = ifile.size;

                this.cmdAcceptedFiles(ext);
                _filesize = Math.floor(totalBytes / 1000000);

                let fileSizeinMB = parseFloat((totalBytes / (1024 * 1024)).toFixed(3));

                this.message = "";
                if (!this.cmdAcceptedFiles(ext)) {
                    this.message = "Unsupported file format.";
                    this.showWarning = true;
                }
                else if (match || fileName.length > 2) {                                      
                    this.message = "A file name can't contain any of the following characters: ~#%\&{}+\|*@!`$=:/;?,.<>";   
                    this.showWarning = true;
                }
                else if (fileSizeinMB == 0 || fileSizeinMB > this.allowableFileSize) {
                    if (fileSizeinMB == 0) {
                        this.message = "Cannot be upload empty file.";
                    }
                    else if (fileSizeinMB > this.allowableFileSize) {
                        this.message = "File size should not be more than " + this.allowableFileSize+"MB.";
                    }
                    this.showWarning = true;
                }

            if (match == false && fileName.length == 2 && fileSizeinMB > 0 && _filesize < this.allowableFileSize && ext != 'exe' && this.cmdAcceptedFiles(ext)) {
                    let currentDate = new Date();
                    this.attachments.push({
                        JurisID: this.JurisID,
                        RefID: this.RefID,
                        SourceID: this.SourceID,
                        SourceType: this.SourceType,
                        Category: ext,
                        Description: ifile.name,
                        TxtAttachID: Guid.newGuid(),
                        BaseAttachFile: base64File,
                        SeqNo: index,
                        FileName: ifile.name,
                        Custom1: ext,
                        FileSize: fileSizeinMB,
                        CreatedDttmUTC: currentDate
                    });
                }

                this.processCount++;

                if (this.processCount == fileCount) {
                    this.cmdFileEmitter();
                }
            }
        myReader.readAsDataURL(ifile);
    }

    cmdFileEmitter() {
        this.onFileAdd.emit(this.attachments);
    }
    
    cmdAcceptedFiles(file: string): boolean {

        let isAccepted: boolean = false;
        if (!this.acceptFileExtensions.toLowerCase()) {
            isAccepted = true;
        }
        else {
            if (this.acceptFileExtensions.toLowerCase().indexOf(file.toLowerCase()) >= 0) {
                    isAccepted = true;
            }
            else {
                isAccepted = false;
            }
        }
        return isAccepted;
    }

    cmdRemoveFile(index: number) {
        (<HTMLInputElement>document.getElementById('file')).value = '';
        this.attachments.splice(index, 1);

        this.cmdFileEmitter();
    }
    cmdDownloadFile(index: number) {

        let txtAttachment: TxtAttach = this.attachments[index];
        let contentType = this.getMIMEType(txtAttachment.Category);
        
        let byteCharacters = atob(txtAttachment.BaseAttachFile);
        let byteNumbers = new Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i++)
            byteNumbers[i] = byteCharacters.charCodeAt(i);

        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: contentType });

        //Code for IE browser issue (Blob not working in IE : Refer https://developer.mozilla.org/en-US/docs/Web/API/Blob)
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }

        let url = window.URL.createObjectURL(blob);
        window.open(url);
    }
    getMIMEType(contentType: string): string {
        let mimeType: string;

        switch (contentType.toUpperCase()) {
            case "JPEG":
            case "JPG":
                {
                    mimeType = 'image/jpeg';
                }
                break;
            case "PNG":
                {
                    mimeType = 'image/png';
                }
                break;
            case "GIF":
                {
                    mimeType = 'image/gif';
                }
                break;
            case 'DOCX':
                {
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
                break;
            case 'XLSX':
                {
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                }
                break;
            case 'PDF':
                {
                    mimeType = 'application/pdf';
                }
                break;
            case 'TXT':
                {
                    mimeType = 'text/plain';
                }
                break;
        }
        return mimeType;
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.commonService.ScrollToTop();
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/file.control.ts